import useAsyncData from "../../../hooks/use-async-data";
import metaService from "../meta.service";
import MetaAttentionCounters from "./meta-attention-counters";

const useMetaAttentionCounters = () => {
  const { data, setData, isLoading, setIsLoading, isError, setIsError } =
    useAsyncData<MetaAttentionCounters | null>(null);

  const load = async (abortSignal: AbortSignal): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await metaService.getAttentionCounters(abortSignal);

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useMetaAttentionCounters;
